import React from "react";
import "./GetMusicOnRaaga.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnRaaga = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music release",
    "Select Raaga Music Distribution",
    "Content delivered to Raaga platform",
    "Reach South Asian listeners worldwide",
    "Track streams & earnings"
  ];

  return (
    <>
      <Helmet>
        <title>Raaga Music Distribution | FT Tunes</title>

        <meta
          name="description"
          content="Distribute your music on Raaga with FT Tunes. Reach millions of listeners across Indian and South Asian music audiences."
        />

        <meta
          name="keywords"
          content="Raaga music distribution, Raaga streaming, South Indian music platform distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="raaga-page">

        {/* HERO */}
        <section className="raaga-hero">
          <Container>

            <img
              src="/Images/raaga-logo.png"
              alt="Raaga"
              className="raaga-logo"
            />

            <h1>Distribute Your Music on Raaga</h1>

            <p>
              Deliver your music to Raaga’s global audience and connect
              with millions of listeners who love Indian and regional music.
            </p>

            <Button
              className="gradient-btn-raaga"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Distribution
            </Button>

          </Container>

          <div className="hero-glow-raaga"></div>
        </section>


        {/* SHOWCASE */}
        <section className="raaga-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Indian Music Lovers Worldwide</h2>

                <p>
                  Raaga is one of the most popular platforms for Indian,
                  devotional, regional, and South Asian music streaming.
                  Expand your fanbase across global audiences.
                </p>

                <Button
                  className="outline-btn-raaga"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-raaga.png"
                  alt="Raaga Music Distribution"
                  className="raaga-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="raaga-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-raaga">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="raaga-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute on Raaga
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-raaga">
                  <h5>Indian Audience Reach</h5>
                  <p>Massive listener base across India & abroad.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-raaga">
                  <h5>Regional Music Focus</h5>
                  <p>Perfect for devotional & regional releases.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-raaga">
                  <h5>High Quality Streaming</h5>
                  <p>Optimized playback for all devices.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-raaga">
                  <h5>Analytics Dashboard</h5>
                  <p>Track performance & revenue insights.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="raaga-cta">
          <Container>

            <h2>Start Your Raaga Music Distribution Today</h2>

            <Button
              className="gradient-btn-raaga big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnRaaga;